import styled, { css } from "styled-components";

import BodyText from "core/BodyText";
import colors from "core/colors";
import Flexbox from "core/Flexbox";
import { rapidEasing } from "core/animation";

import Success from "core/ReusableIcons/Success";
import Warning from "core/ReusableIcons/Warning";

import { convertPxToRem } from "frontend/components/helpers";

const ERROR_STYLES = {
    BORDER: css`
        box-shadow: inset 0 ${convertPxToRem({ px: -6 })} 0
            ${colors.functional.lightMode.sangria};
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
    `,
    TEXT_COLOR: colors.functional.lightMode.sangria
};

const WARNING_STYLES = {
    TEXT_COLOR: colors.alternative.lightMode.tang,
    ICON_COLOR: colors.alternative.lightMode.tang
};

const SUCCESS_STYLES = {
    ICON_COLOR: colors.alternative.lightMode.pine
};

export const FooterContentContainer = styled(Flexbox)``;

export const ErrorBodyText = styled(BodyText).attrs({
    copyColor: ERROR_STYLES.TEXT_COLOR,
    size: "sm",
    type: "div"
})``;

export const WarningBodyText = styled(BodyText).attrs({
    copyColor: WARNING_STYLES.TEXT_COLOR,
    size: "sm",
    type: "div"
})`
    display: flex;
    align-items: center;
`;

export const WarningIcon = styled(Warning).attrs({
    fillColor: WARNING_STYLES.ICON_COLOR,
    size: "xs"
})`
    margin-left: ${convertPxToRem({ px: 4 })};
`;

export const SuccessIcon = styled(Success).attrs({
    fillColor: SUCCESS_STYLES.ICON_COLOR,
    size: "md"
})``;

export const HoverBodyText = styled(BodyText)`
    position: absolute;
    bottom: ${convertPxToRem({ px: 12 })};
    right: ${convertPxToRem({ px: 12 })};
    padding: ${convertPxToRem({ px: 3 })};
    border-radius: ${convertPxToRem({ px: 3 })};
    background-color: rgba(255, 255, 255, 0.6);

    &:first-of-type {
        top: ${convertPxToRem({ px: 12 })};
        bottom: unset;
    }
`;

export const FilePreviewContainer = styled.div`
    ${({ isImageProcessing }) =>
        isImageProcessing &&
        css`
            ${Image} {
                display: none;
            }
        `}
`;

export const Image = styled.img``;

export const SelectedCheckboxContainer = styled.div`
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;

    label {
        display: block;
        width: 100%;
        height: 100%;
        transition: all ${rapidEasing};
        border: ${convertPxToRem({ px: 4 })} solid transparent;

        user-select: none;

        ${({ isHovered, isCheckboxSelected }) =>
            (isHovered || isCheckboxSelected) &&
            css`
                border-color: ${colors.functional.secondary.parrot};
            `}

        input {
            + span {
                display: ${({ isHovered, isCheckboxSelected }) =>
                    isHovered || isCheckboxSelected ? "block" : "none"};
                line-height: 0;

                &:before {
                    top: ${convertPxToRem({ px: 12 })};
                    left: ${convertPxToRem({ px: 12 })};
                    margin: 0;
                }
            }

            // only show focus on keyboard not with mouse:
            &:focus:not(.focus-visible),
            &:active {
                + span:before {
                    outline: none;
                    box-shadow: none;
                    border: none;
                }
            }

            &:focus {
                + span:before {
                    outline: 3px solid ${colors.functional.secondary.slime};
                }
            }
        }
    }

    ${HoverBodyText} {
        display: ${({ isHovered, isCheckboxSelected }) =>
            isHovered || isCheckboxSelected ? "block" : "none"};
    }
`;

export const ProcessingContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
